<!-- Modals -->
<app-deprecated-modal-form
    #departmentModal
    headerText="{{ 'offer-letter.createNewDepartment' | translate }}"
    [form]="departmentForm"
    (save)="createAndSetDepartment(departmentForm)"
    (cancel)="onCancel()"
>
    <app-department-form #departmentForm></app-department-form>
</app-deprecated-modal-form>

<app-deprecated-modal-form
    #positionModal
    headerText="{{ 'offer-letter.createNewPosition' | translate }}"
    [form]="positionForm"
    (save)="createAndSetPosition(positionForm)"
    (cancel)="onCancel()"
>
    <app-position-form #positionForm></app-position-form>
</app-deprecated-modal-form>

<app-deprecated-modal-form
    #officeModal
    headerText="{{ 'offer-letter.createNewOffice' | translate }}"
    [form]="officeForm"
    (save)="createAndSetOffice(officeForm)"
    (cancel)="onCancel()"
>
    <app-office-form #officeForm></app-office-form>
</app-deprecated-modal-form>

<!--Loader-->
<div *ngIf="isLoading" class="ui active inverted dimmer">
    <div class="ui loader"></div>
</div>

<form autocomplete="nope" #form="ngForm">
    <p>{{ 'offer-letter.infoTemplate' | translate }}</p>

    <!-- Merge fields based on selected offer letter template -->
    <ng-container *ngFor="let formInputAttribute of mergeFieldFormInputAttributes; let i = index">
        <div [ngSwitch]="formInputAttribute.inputType">
            <!-- Input Text Field -->
            <div class="app-grid" *ngSwitchCase="mergeFieldFormInputTypes.text">
                <mat-form-field class="columns-4 small-columns-12">
                    <mat-label>{{ formInputAttribute.label | translate }}</mat-label>
                    <input
                        type="text"
                        matInput
                        [(ngModel)]="offerLetter[formInputAttribute.attributeName]"
                        [name]="formInputAttribute.attributeName"
                        [attr.name]="formInputAttribute.attributeName"
                        [required]="formInputAttribute.required"
                        #textInput="ngModel"
                    />
                    <mat-error *ngIf="form.submitted && textInput.invalid">
                        {{ 'offer-letter.errorIsRequired' | translate: { x: formInputAttribute.label } }}
                    </mat-error>
                </mat-form-field>
            </div>

            <!-- Input Number Field -->
            <div class="app-grid" *ngSwitchCase="mergeFieldFormInputTypes.number">
                <mat-form-field class="columns-4 small-columns-12">
                    <mat-label>{{ formInputAttribute.label | translate }}</mat-label>
                    <input
                        type="number"
                        matInput
                        [(ngModel)]="offerLetter[formInputAttribute.attributeName]"
                        [name]="formInputAttribute.attributeName"
                        [attr.name]="formInputAttribute.attributeName"
                        [required]="formInputAttribute.required"
                        #textInput="ngModel"
                    />
                    <mat-error *ngIf="form.submitted && textInput.invalid">
                        {{ 'offer-letter.errorIsRequired' | translate: { x: formInputAttribute.label } }}
                    </mat-error>
                </mat-form-field>
            </div>

            <!-- Date Field -->
            <div class="app-grid" *ngSwitchCase="mergeFieldFormInputTypes.date">
                <mat-form-field class="columns-4 small-columns-12">
                    <mat-label>{{ formInputAttribute.label | translate }}</mat-label>
                    <input
                        matInput
                        [matDatepicker]="i"
                        [min]="formInputAttribute.attributeName === 'expiresOn' ? today : null"
                        [name]="formInputAttribute.attributeName"
                        [attr.name]="formInputAttribute.attributeName"
                        [required]="formInputAttribute.required"
                        [(ngModel)]="offerLetter[formInputAttribute.attributeName]"
                        placeholder="{{ 'offer-letter.chooseADate' | translate }}"
                        #datePicker="ngModel"
                    />
                    <mat-datepicker-toggle matSuffix [for]="i"></mat-datepicker-toggle>
                    <mat-datepicker #i></mat-datepicker>
                    <mat-error *ngIf="form.submitted && datePicker.hasError('required')">
                        {{ 'offer-letter.errorIsRequired' | translate: { x: formInputAttribute.label } }}
                    </mat-error>
                    <mat-error *ngIf="form.submitted && datePicker.hasError('matDatepickerMin')">
                        {{ 'offer-letter.errorMustBe' | translate: { x: today | appDate } }}
                    </mat-error>
                </mat-form-field>
            </div>

            <!-- Dropdown Field -->
            <div class="app-grid" *ngSwitchCase="mergeFieldFormInputTypes.dropdown">
                <mat-form-field class="columns-4 small-columns-12">
                    <mat-label appRemoveAriaOwns>{{ formInputAttribute.label | translate }}</mat-label>
                    <mat-select
                        [name]="formInputAttribute.attributeName"
                        [attr.name]="formInputAttribute.attributeName"
                        [required]="formInputAttribute.required"
                        [(ngModel)]="offerLetter[formInputAttribute.attributeName]"
                        #selectInput="ngModel"
                        [compareWith]="compareWith"
                    >
                        <mat-option
                            class="create"
                            *ngIf="formInputAttribute.dropDownOptions.showAddButton"
                            (click)="showModal(formInputAttribute)"
                        >
                            {{ formInputAttribute.dropDownOptions.addButtonLabel | translate }}
                        </mat-option>

                        <mat-option *ngFor="let option of formInputAttribute.dropDownOptions.options" [value]="option">
                            <!-- Show option based on option label -->
                            <ng-container *ngIf="formInputAttribute.dropDownOptions.optionLabel">
                                {{ option[formInputAttribute.dropDownOptions.optionLabel] | translate }}
                            </ng-container>
                            <ng-container *ngIf="!formInputAttribute.dropDownOptions.optionLabel">
                                {{ 'offer-letter.merge-fields.dropdown-options.' + option | translate }}
                            </ng-container>
                        </mat-option>
                    </mat-select>

                    <mat-error *ngIf="form.submitted && selectInput.invalid">
                        {{ 'offer-letter.errorIsRequired' | translate: { x: formInputAttribute.label } }}
                    </mat-error>
                </mat-form-field>
            </div>
        </div>
    </ng-container>
</form>
